import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import metaCapiPixelsAPI from '../../api/metaCapiPixels';

const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    creatingItem: false,
    deletingItem: false,
    updatingItem: false,
  },
};

export const getters = {
  getPixels(_state) {
    return _state.records.sort((a, b) => a.id - b.id);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit(types.default.SET_META_CAPI_PIXEL_UI_FLAG, { fetchingList: true });
    try {
      const response = await metaCapiPixelsAPI.get();
      commit(types.default.SET_META_CAPI_PIXELS, response.data.payload.pixels);
    } catch (error) {
      // silent
    } finally {
      commit(types.default.SET_META_CAPI_PIXEL_UI_FLAG, {
        fetchingList: false,
      });
    }
  },

  async create({ commit }, params) {
    commit(types.default.SET_META_CAPI_PIXEL_UI_FLAG, { creatingItem: true });
    try {
      const response = await metaCapiPixelsAPI.create(params);
      commit(
        types.default.ADD_META_CAPI_PIXEL,
        response.data.payload.pixel
      );
    } catch (error) {
      throw error;
    } finally {
      commit(types.default.SET_META_CAPI_PIXEL_UI_FLAG, {
        creatingItem: false,
      });
    }
  },

  async update({ commit }, { id, ...updateObj }) {
    commit(types.default.SET_META_CAPI_PIXEL_UI_FLAG, { updatingItem: true });
    try {
      const response = await metaCapiPixelsAPI.update(id, updateObj);
      commit(
        types.default.UPDATE_META_CAPI_PIXEL,
        response.data.payload.pixel
      );
    } catch (error) {
      throw error;
    } finally {
      commit(types.default.SET_META_CAPI_PIXEL_UI_FLAG, {
        updatingItem: false,
      });
    }
  },

  async delete({ commit }, id) {
    commit(types.default.SET_META_CAPI_PIXEL_UI_FLAG, { deletingItem: true });
    try {
      await metaCapiPixelsAPI.delete(id);
      commit(types.default.DELETE_META_CAPI_PIXEL, id);
    } catch (error) {
      throw error;
    } finally {
      commit(types.default.SET_META_CAPI_PIXEL_UI_FLAG, {
        deletingItem: false,
      });
    }
  },
};

export const mutations = {
  [types.default.SET_META_CAPI_PIXEL_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_META_CAPI_PIXELS]: MutationHelpers.set,
  [types.default.ADD_META_CAPI_PIXEL]: MutationHelpers.create,
  [types.default.DELETE_META_CAPI_PIXEL]: MutationHelpers.destroy,
  [types.default.UPDATE_META_CAPI_PIXEL]: MutationHelpers.update,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
